/** Campos — Informe de avance (Integración Sensorial) según plantilla «Informe de avances» */

export const TIPO_CAMPO = {
  LINEA: "linea",
  MULTILINEA: "multilinea",
  FECHA: "fecha",
};

export const CAMPOS_DATOS_GENERALES = [
  { key: "nombreApellido", label: "Nombre y apellido", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "fnacimiento", label: "Fecha de nacimiento", tipo: TIPO_CAMPO.FECHA },
  { key: "edadTexto", label: "Edad", tipo: TIPO_CAMPO.LINEA, maxLength: 25 },
  { key: "escuela", label: "Escuela", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "tutorLegal", label: "Padre / Madre / Tutor legal", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "domicilio", label: "Domicilio", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "fechaEvaluacion", label: "Fecha de la evaluación", tipo: TIPO_CAMPO.FECHA },
  { key: "fechaInforme", label: "Fecha de informe", tipo: TIPO_CAMPO.FECHA },
  { key: "diagnostico", label: "Diagnóstico", tipo: TIPO_CAMPO.LINEA, maxLength: 100 },
  { key: "elaboradoPor", label: "Elaborado por", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  {
    key: "cantidadSesionesRecibidas",
    label: "Cantidad de sesiones recibidas",
    tipo: TIPO_CAMPO.LINEA,
    maxLength: 20,
  },
];

export const CAMPOS_SECCIONES = [
  { key: "motivoConsulta", label: "Motivo de consulta", rows: 4 },
  {
    key: "conductaObservada",
    label: "Conducta observada en sesiones y avances",
    rows: 6,
  },
  {
    key: "tecnicasUtilizadas",
    label: "Técnicas utilizadas en terapia",
    rows: 5,
  },
  { key: "aspectosFortalecer", label: "Aspectos para fortalecer", rows: 5 },
  { key: "recomendaciones", label: "Recomendaciones", rows: 5 },
  {
    key: "recomendacionesCentroEducativo",
    label: "Recomendaciones para el centro educativo",
    rows: 5,
  },
  { key: "cantidadSesiones", label: "Cantidad de sesiones (periodo)", rows: 2 },
];

export const CAMPOS_CIERRE = [
  { key: "recibidoPadre", label: "Recibido (padre/madre o tutor)", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
];
